<template>
<div>
  <div class="row" style="height: 60px"></div>
  <div class="row titleRow">
    <div class="col">
      <h1>{{$t('options.title')}}</h1>
    </div>
  </div>
  <div v-for="i in Math.ceil((displayedOptions.length)/nbColumn)" :key="i" class="row listOfButtons">
    <div v-for="(option, index) in displayedOptions.slice((i-1)*nbColumn, (i-1)*nbColumn+nbColumn)" :key="index" class="col">
      <button :disabled="findOptionById(option.id).active" :class="'btn btn-secondary ' + ((findOptionById(option.id).active || findWithAttr(addedOptions, 'id', option.id) !== -1)  ? 'bg-color' : '')" @click="addElementToList(option)">
        {{option.name + ((!findOptionById(option.id).active) ? ' ('+ option.price + '€)' : '') }}
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h3>{{$t('options.offerPrice') + ': ' + ((parseFloat(selectedOffer.recurrentPrice) + parseFloat(offerPrice)).toFixed(2))}} <span v-html="currency"></span> / {{this.getPeriodTranslation(selectedOffer.recurrentTime, 1).toLowerCase()}}</h3>
    </div>
  </div>
  <div class="row">
    <div class="col overFooter">
      <button type="submit" class="btn btn-primary bg-color alignRight" @click="saveData()">{{$t('general.validPresta')}}</button>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'options',
  data () {
    return {
      nbColumn: 3,
      selectedOffer: this.$store.state.form.resultJson.offer.selectedOffer,
      currency: this.$store.state.config.mainconfig.currency,
      displayedOptions: [],
      addedOptions: [],
      offerPrice: 0
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'Options', isAuthorized: true, data: this.dataTosave});
  },
  activated: function () {
    this.selectedOffer = this.$store.state.form.resultJson.offer.selectedOffer;
    this.resetOptions();
    // S'il y a 4 ou moins objectifs activés, on en affiche 2 par colonne
    if (this.displayedOptions.length <= 4) {
      this.nbColumn = 2;
    } else {
      this.nbColumn = 3;
    }
  },
  methods: {
    saveData: function () {
      this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataTosave);
    },
    alreadyListed: function (item) {
      for (var i = 0; i < this.addedOptions.length; i++) {
        if (item === this.addedOptions[i].id) {
          return i;
        }
      }
      return false;
    },
    findOptionById: function (id) {
      let returnOption = false;
      this.selectedOffer.options.forEach(function (option) {
        if (option.id === id) {
          returnOption = option;
        }
      });
      return returnOption;
    },
    findWithAttr: function (array, attr, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    },
    addElementToList: function (item) {
      var alreadyListed = this.alreadyListed(item.id);
      if (alreadyListed === false) {
        this.addedOptions.push(item);
        this.offerPrice += parseFloat(item.price);
      } else {
        this.addedOptions.splice(alreadyListed, 1);
        this.offerPrice -= parseFloat(item.price);
      }
    },
    resetOptions: function () {
      var updatedArray = [];
      var index = [];
      for (var indexAddedOptions = 0; indexAddedOptions < this.addedOptions.length; indexAddedOptions++) {
        var test = true;
        var indexOfferOption = this.findWithAttr(this.selectedOffer.options, 'id', this.addedOptions[indexAddedOptions].id);
        if (indexOfferOption !== -1) {
          if (this.selectedOffer.options[indexOfferOption].active === true) {
            test = false;
            this.offerPrice -= this.addedOptions[indexAddedOptions].price;
          }
        }
        index.push(test);
      }
      for (var indexTable = 0; indexTable < this.addedOptions.length; indexTable++) {
        if (index[indexTable] === true) {
          updatedArray.push(this.addedOptions[indexTable]);
        }
      }
      this.addedOptions = updatedArray;

      this.displayedOptions = [];
      this.options.forEach(function (option) {
        if (this.findOptionById(option.id) && this.findOptionById(option.id).price !== '') {
          this.displayedOptions.push({...option});
          this.displayedOptions[this.displayedOptions.length - 1].price = this.findOptionById(option.id).price;
        } else if (option.price !== '') {
          this.displayedOptions.push(option);
        }
      }, this);
    },
    getPeriodTranslation: function (period, duration) {
      let translatedPeriod = '';
      switch (period) {
        case 'week':
          translatedPeriod = this.$tc('config.commitments.week', (duration > 1) ? 2 : 1);
          break;
        case 'month':
          translatedPeriod = this.$t('config.commitments.month', (duration > 1) ? 2 : 1);
          break;
        case 'year':
          translatedPeriod = this.$tc('config.commitments.year', (duration > 1) ? 2 : 1);
          break;
      }
      return translatedPeriod;
    }
  },
  computed: {
    dataTosave: function () {
      return {
        moreOptions: {
          options: [...this.addedOptions],
          totalOfferPrice: parseFloat((parseFloat(this.selectedOffer.recurrentPrice) + parseFloat(this.offerPrice)).toFixed(2))
        }
      };
    },
    options: function () {
      return this.$store.state.config.options;
    }

  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/Options.vue